import dot from 'dot-object';
import {useFormikContext} from 'formik';
import React, {useEffect} from 'react';

type Props = {
  offset?: number;
  parent?: HTMLElement;
};

const getOffsetTop = (element: HTMLElement | null) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent as HTMLElement;
  }
  return offsetTop;
};

export const ScrollToError: React.FC<Props> = ({offset = 150, parent = window}) => {
  const {errors, isValid, isSubmitting, setFieldTouched} = useFormikContext();

  useEffect(() => {
    if (isValid || !isSubmitting) return;
    const errorKey = Object.keys(dot.dot(errors))[0];
    if (!errorKey) return;
    setFieldTouched(errorKey);
    let el = document.querySelector(`label[for="${errorKey}"]`);
    if (!el) {
      el = document.getElementsByName(errorKey)[0];
    }
    if (el) {
      const offsetTop = getOffsetTop(el as HTMLElement);
      parent.scrollTo({top: offsetTop - offset, behavior: 'smooth'});
    }
  }, [isValid, isSubmitting]);

  return null;
};
